/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BookCategory {
  BEGINNER = "BEGINNER",
  INTERMEDIATE = "INTERMEDIATE",
  ADVANCED = "ADVANCED",
  UNPLUGGED = "UNPLUGGED",
  ARTIFICIAL_INTELLIGENCE = "ARTIFICIAL_INTELLIGENCE",
  CYBER_SECURITY = "CYBER_SECURITY",
  CODING = "CODING",
  MISCELLANEOUS = "MISCELLANEOUS",
}
